import { Lock } from 'lucide-react';
import { Label } from '@/components/ui/label';
import { useAgendaInstalacaoMarcada } from '@/hooks/useAgendaInstalacaoMarcada';
import { rotuloTurno, turnoDaAgenda } from '@/lib/turnoInstalacao';

interface AgendaFixaTravadaProps {
  itemId: string;
  quadroAtual: string;
  value: string | null | undefined;
}

const TZ = 'America/Sao_Paulo';

function quandoCurto(iso: string): string {
  return new Intl.DateTimeFormat('pt-BR', {
    timeZone: TZ, day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit',
  }).format(new Date(iso)).replace(',', '');
}

function agendaTexto(iso: string): string {
  const dia = new Intl.DateTimeFormat('pt-BR', { timeZone: TZ, day: '2-digit', month: '2-digit' }).format(new Date(iso));
  const turno = turnoDaAgenda(iso);
  return turno ? `${dia}, das ${rotuloTurno(turno)}` : `${dia}, sem turno`;
}

/**
 * A DATA DA FIXA TEM UMA PORTA (Douglas 30/10/2026, maquete aprovada): quem
 * inputa marca a data e o turno no Inputar da Triagem Input. Aqui ela só aparece.
 * Depois do input, muda pelo Reagendar da Triagem Em instalação; o banco recusa
 * qualquer outra gravação (zz_agenda_fixa_porta_unica).
 */
export function AgendaFixaTravada({ itemId, quadroAtual, value }: AgendaFixaTravadaProps) {
  const antesDoInput = quadroAtual === 'COMERCIAL' || quadroAtual === 'CONTRATO_PRIME';
  const { data: marcada } = useAgendaInstalacaoMarcada(itemId, !antesDoInput && !!value);

  return (
    <div className="col-span-2 space-y-1">
      <Label className="text-sm font-medium flex items-center gap-1.5">
        <Lock className="h-3.5 w-3.5 text-muted-foreground" />
        Data e turno da instalação
      </Label>
      {antesDoInput || !value ? (
        <>
          <p className="text-sm font-semibold text-foreground">Sem data ainda</p>
          <p className="text-[11px] text-muted-foreground">A data da fibra é lançada no Inputar, pela Triagem Input.</p>
        </>
      ) : (
        <>
          <p className="text-sm font-semibold text-foreground tabular-nums">{agendaTexto(value)}</p>
          <p className="text-[11px] text-muted-foreground">
            {marcada?.quem
              ? `${marcada.origem === 'reagendamento' ? 'Reagendada' : 'Inputada'} por ${marcada.quem}, ${quandoCurto(marcada.quando)}. `
              : ''}
            Muda só pelo Reagendar da Triagem Em instalação.
          </p>
        </>
      )}
    </div>
  );
}
